import { render, staticRenderFns } from "./mallHeader.vue?vue&type=template&id=3e0ca811&scoped=true&"
import script from "./mallHeader.vue?vue&type=script&lang=js&"
export * from "./mallHeader.vue?vue&type=script&lang=js&"
import style0 from "./mallHeader.vue?vue&type=style&index=0&id=3e0ca811&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0ca811",
  null
  
)

export default component.exports